// Copyright (c) 2016 Deere & Company

export const getClaimRoutes = (claimKey, pin) => {

    const modifiedPin = pin ? pin : '';

    const map = {
        JDP: `/claims/jdp/new/${modifiedPin}`,
        MTC: `/claims/maintenance-plan/new/${modifiedPin}`,
        PDI: '/claims/mass-channel-pdi/new',
        PDP: '/claims/mass-channel-pdi/new',
        PMI: `/claims/incentive/new/${modifiedPin}`,
        WRP: `/claims/wear-parts/new/${modifiedPin}`,
        ZNRM: `/claims/normal/new/${modifiedPin}`,
        ZPAR: `/claims/parts/new/${modifiedPin}`,
        ZPIP: `/claims/pip/new/${modifiedPin}`,
        ZSPA: `/claims/spa/new/${modifiedPin}`,
        ZZBT: `/claims/battery/new/${modifiedPin}`,
        ZZNS: '/claims/attachment/new',
        ZZTK: `/claims/track/new/${modifiedPin}`
    };

    return map[claimKey];

};



// WEBPACK FOOTER //
// ./src/shared/components/create-claim-modal/get-claim-routes-service.js